// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4161 ? "88603698" : chunkId) + "." + {"1453":"f47beef230807419","4161":"17cb8d71cd1c73d8"}[chunkId] + ".js";
};